import { HistoricalGraph } from "@/components/HistoricalGraph"

import { HEIGHT, useHistoricalPath, WIDTH } from "./stats.state"

export const UpdatesHistoricalGraph = () => {
  const path = useHistoricalPath()

  return path ? (
    <HistoricalGraph path={path} size={{ width: WIDTH, height: HEIGHT }} />
  ) : null
}
